import ReactGA from "react-ga4";

import { getCustomerID, getLeadID, getPhoneNo } from "../utils/storage";
import { analyticsEvent, setUserAttributes } from "./google";
import { convertUserType, generateSessionId, getUpdatedCustomerID, getVisitType, setBucketValue, setLoanType, setProductNameByID } from "./script";

import Cookies from "js-cookie";

/*------------------------------------------------*
 Events
*------------------------------------------------*/

// ONB029 - enter_otp_verify_otp_clk
export const googleEvent_ONB029 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "enter_mobile",
    phone_number: getPhoneNo(),
  });

  analyticsEvent({
    event_id: "ONB029",
    event_name: "enter_otp_verify_otp_clk",
    event_category: "enter_otp",
    action: "click",
    level: "verify_otp",
    screen_name: "enter_otp",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ018 - pan_confirmation_info_correct_<yes|no>_clk
export const googleEvent_LOJ018 = (level, user_pancard) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "pan_verification",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    user_pancard: user_pancard,
  });

  analyticsEvent({
    event_id: "LOJ018",
    event_name: level === "yes" ? "pan_confirmation_info_correct_yes_clk" : "pan_confirmation_info_correct_no_clk",
    event_category: "pan_confirmation",
    action: "click",
    level: level,
    screen_name: "pan_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ038 - kyc_verification_next2_clk
export const googleEvent_LOJ038 = (kyc_mode) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "pan_confirmation",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    kyc_mode: kyc_mode, // digilocker|aadhar
  });

  analyticsEvent({
    event_id: "LOJ038",
    event_name: "kyc_verification_next2_clk",
    event_category: "kyc_verification",
    action: "click",
    level: "next2",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ091 - sv_loan_approved
export const googleEvent_LOJ091 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "select_your_loan",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ091",
    event_name: "sv_loan_approved",
    event_category: "screen_view",
    action: "view",
    level: "loan_approved",
    screen_name: "loan_approved",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ170 - key_fct_stat_accept_clk
export const googleEvent_LOJ170 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "penny_drop",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ170",
    event_name: "key_fct_stat_accept_clk",
    event_category: "key_fact_statment",
    action: "click",
    level: "i_accept",
    screen_name: "key_fact_statment",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// ONB018 - sv_enter_mobile
export const googleEvent_ONB018 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "",
    visit_type: getVisitType(),
  });

  analyticsEvent({
    event_id: "ONB018",
    event_name: "sv_enter_mobile",
    event_category: "screen_view",
    action: "view",
    level: "enter_mobile",
    screen_name: "enter_mobile",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// ONB021 - enter_mobile_get_otp_clk
export const googleEvent_ONB021 = (phone_number) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "",
    phone_number: phone_number,
  });

  analyticsEvent({
    event_id: "ONB021",
    event_name: "enter_mobile_get_otp_clk",
    event_category: "enter_mobile",
    action: "click",
    level: "get_otp",
    screen_name: "enter_mobile",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// ONB025 - sv_enter_otp
export const googleEvent_ONB025 = (phone_number) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "enter_mobile",
    phone_number: phone_number,
  });

  analyticsEvent({
    event_id: "ONB025",
    event_name: "sv_enter_otp",
    event_category: "screen_view",
    action: "view",
    level: "enter_otp",
    screen_name: "enter_otp",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// HOM001 - sv_home_dashboard
export const googleEvent_HOM001 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "enter_otp",
    phone_number: getPhoneNo(),
    visit_type: getVisitType(),
  });

  analyticsEvent({
    event_id: "HOM001",
    event_name: "sv_home_dashboard",
    event_category: "screen_view",
    action: "view",
    level: "home_dashboard",
    screen_name: "home_dashboard",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ005 - user_auth_next_clk
export const googleEvent_LOJ005 = (user_name, user_email) => {
  ReactGA.set({
    user_properties: {
      session_id: generateSessionId(),
      customer_id: Cookies.get("customerID") || "",
      client_id: "",
      advertising_id: "",
      gclid: "",
      fcmtoken: "",
      user_type: convertUserType(),
      product_type: setProductNameByID(),
      lead_id: Number(localStorage.getItem("leadID")) || "",

      platform: "web",
      app_version: localStorage.getItem("appVersion") ?? "",
      utm_source: localStorage.getItem("utm_source") ?? "",
      utm_medium: "",
      utm_campaign: "",
      utm_term: "",
      utm_content: "",
      user_insider: "0", // emp (1) / cust (0)
      flag_prod: "1",
      previous_screen: "loan_purpose",
      phone_number: getPhoneNo(),
      loan_type: setLoanType(),
      journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",

      // custom user attributes
      user_name,
      user_email,
    },
  });

  // Log GA4 custom event
  ReactGA.event("user_auth_next_clk", {
    event_id: "LOJ005",
    event_category: "user_authenticity",
    action: "click",
    level: "next",
    screen_name: "user_authenticity",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });

  // setUserAttributes({
  //   session_id: generateSessionId(),
  //   customer_id: Cookies.get("customerID") || "",
  //   client_id: "",
  //   advertising_id: "",
  //   gclid: "",
  //   fcmtoken: "",
  //   user_type: convertUserType(),
  //   product_type: setProductNameByID(),
  //   lead_id: Number(localStorage.getItem("leadID")) || "",

  //   platform: "web",
  //   app_version: localStorage.getItem("appVersion") ?? "",
  //   utm_source: localStorage.getItem("utm_source") ?? "",
  //   utm_medium: "",
  //   utm_campaign: "",
  //   utm_term: "",
  //   utm_content: "",
  //   user_insider: "0", // emp (1) / cust (0)
  //   flag_prod: "1",
  //   previous_screen: "loan_purpose",
  //   phone_number: getPhoneNo(),
  //   loan_type: setLoanType(),
  //   journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  //   user_name: user_name,
  //   user_email: user_email,
  // });

  // analyticsEvent({
  //   event_id: "LOJ005",
  //   event_name: "user_auth_next_clk",
  //   event_category: "user_authenticity",
  //   action: "click",
  //   level: "next",
  //   screen_name: "user_authenticity",
  //   event_type_1: "frontend",
  //   event_type_2: "interactive",
  // });
};

// LOJ029 - kyc_verification_next_clk
export const googleEvent_LOJ029 = (kyc_mode) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "reference_details",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    kyc_mode: kyc_mode,
  });

  analyticsEvent({
    event_id: "LOJ029",
    event_name: "kyc_verification_next_clk",
    event_category: "kyc_verification",
    action: "click",
    level: "next",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ042 - loan_purpose_sel
export const googleEvent_LOJ042 = (loan_pupose) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "proff_details_employment",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    loan_pupose: loan_pupose,
  });

  analyticsEvent({
    event_id: "LOJ042",
    event_name: "loan_purpose_sel",
    event_category: "loan_purpose",
    action: "select",
    level: "purpose",
    screen_name: "loan_purpose",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ046 - loan_amount_next_clk
export const googleEvent_LOJ046 = (loan_amount_bucket) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "kyc_screen",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    loan_amount_bucket: setBucketValue(loan_amount_bucket),
  });

  analyticsEvent({
    event_id: "LOJ046",
    event_name: "loan_amount_next_clk",
    event_category: "loan_amount",
    action: "click",
    level: "next",
    screen_name: "loan_amount",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ049 - gender_sel
export const googleEvent_LOJ049 = (level, gender) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "loan_amount",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    gender: gender,
  });

  analyticsEvent({
    event_id: "LOJ049",
    event_name: "gender_sel",
    event_category: "gender",
    action: "select",
    level: level,
    screen_name: "gender",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ052 - marital_status_sel
export const googleEvent_LOJ052 = (level, marital) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "gender",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    marital: marital,
  });

  analyticsEvent({
    event_id: "LOJ052",
    event_name: "marital_status_sel",
    event_category: "marital_status",
    action: "select",
    level: level,
    screen_name: "marital_status",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ055 - personal_info_highest_edu_sel
export const googleEvent_LOJ055 = (level, education) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "marital_status",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    education: education,
  });

  analyticsEvent({
    event_id: "LOJ055",
    event_name: "personal_info_highest_edu_sel",
    event_category: "personal_info",
    action: "select",
    level: level,
    screen_name: "personal_info",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ058 - proff_details_employment_sel
export const googleEvent_LOJ058 = (level, employment) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "personal_info",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    employment: employment,
  });

  analyticsEvent({
    event_id: "LOJ058",
    event_name: "proff_details_employment_sel",
    event_category: "proff_details",
    action: "select",
    level: level,
    screen_name: "proff_details_employment",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ060 - proff_details_payment_sel
export const googleEvent_LOJ060 = (level, payment_mode) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "pan_confirmation",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    payment_mode: payment_mode,
  });

  analyticsEvent({
    event_id: "LOJ060",
    event_name: "proff_details_payment_sel",
    event_category: "proff_details",
    action: "select",
    level: level,
    screen_name: "proff_details_payment",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ063 - employ_details_comp_next_clk
export const googleEvent_LOJ063 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "proff_details_payment",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ063",
    event_name: "employ_details_comp_next_clk",
    event_category: "employ_details",
    action: "click",
    level: "next_company",
    screen_name: "employ_details",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ065 - employ_details_ind_sel
export const googleEvent_LOJ065 = (level, industry) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "proff_details_employment",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    industry: industry,
  });

  analyticsEvent({
    event_id: "LOJ065",
    event_name: "employ_details_ind_sel",
    event_category: "employ_details",
    action: "select",
    level: level,
    screen_name: "employ_details_ind",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ067 - employ_details_designation_sel
export const googleEvent_LOJ067 = (level, designation) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "proff_details_employment",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    designation: designation,
  });

  analyticsEvent({
    event_id: "LOJ067",
    event_name: "employ_details_designation_sel",
    event_category: "employ_details",
    action: "select",
    level: level,
    screen_name: "employ_details_designation",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ072 - proff_details_mon_income_next_clk
export const googleEvent_LOJ072 = (income_bucket) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "employ_details_designation",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    income_bucket: setBucketValue(income_bucket),
  });

  analyticsEvent({
    event_id: "LOJ072",
    event_name: "proff_details_mon_income_next_clk",
    event_category: "proff_details",
    action: "click",
    level: "next_monthly_income",
    screen_name: "proff_details_mon_income",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ075 - proff_details_work_exp_sel
export const googleEvent_LOJ075 = (experience) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "proff_details_work_exp",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    experience: experience,
  });

  analyticsEvent({
    event_id: "LOJ075",
    event_name: "proff_details_work_exp_sel",
    event_category: "proff_details",
    action: "select",
    level: "work_experience_<work_expeirence>",
    screen_name: "proff_details_work_exp",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ078 - proff_details_sal_date_sel
export const googleEvent_LOJ078 = (level, salary_date) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "proff_details_mon_income",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    salary_date: `${salary_date}`,
  });

  analyticsEvent({
    event_id: "LOJ078",
    event_name: "proff_details_sal_date_sel",
    event_category: "proff_details",
    action: "select",
    level: `${level}`,
    screen_name: "proff_details_sal_date",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ085 - resi_details_address_next_clk
export const googleEvent_LOJ085 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "proff_details_sal_date",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ085",
    event_name: "resi_details_address_next_clk",
    event_category: "resi_details",
    action: "click",
    level: "next_address",
    screen_name: "resi_details_address",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ090 - sel_your_loan_continue_clk
export const googleEvent_LOJ090 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "resi_details_address",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    emi_plan: "",
    offer_type: "",
  });

  analyticsEvent({
    event_id: "LOJ090",
    event_name: "sel_your_loan_continue_clk",
    event_category: "select_your_loan",
    action: "click",
    level: "continue",
    screen_name: "select_your_loan",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ094 - loan_approved_continue_clk
export const googleEvent_LOJ094 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "select_your_loan",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ094",
    event_name: "loan_approved_continue_clk",
    event_category: "loan_approved",
    action: "click",
    level: "continue",
    screen_name: "loan_approved",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ188 - ref_details_btmsld_ref_confirm_<yes|no>_clk
export const googleEvent_LOJ188_yes = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "user_authenticity",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ188",
    event_name: "ref_details_btmsld_ref_confirm_yes_clk",
    event_category: "reference_details",
    action: "click",
    level: "btmsld_ref_confirm_yes",
    screen_name: "reference_details",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

export const googleEvent_LOJ188_no = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "penny_drop",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ188",
    event_name: "ref_details_btmsld_ref_confirm_no_clk",
    event_category: "reference_details",
    action: "click",
    level: "btmsld_ref_confirm_no",
    screen_name: "reference_details",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ135 - sv_kyc_verification_selfie
export const googleEvent_LOJ135 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "kyc_verification",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ135",
    event_name: "sv_kyc_verification_selfie",
    event_category: "screen_view",
    action: "view",
    level: "kyc_verification",
    screen_name: "kyc_verification_selfie",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ139 - kyc_verification_selfie_<retake|submit>_clk
export const googleEvent_LOJ139_retake = (level) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "kyc_verification",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ139",
    event_name: "kyc_verification_selfie_retake_clk",
    event_category: "kyc_verification",
    action: "click",
    level: level,
    screen_name: "kyc_verification_selfie",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

export const googleEvent_LOJ139_submit = (level) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "loan_approved",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ139",
    event_name: "kyc_verification_selfie_submit_clk",
    event_category: "kyc_verification",
    action: "click",
    level: level,
    screen_name: "kyc_verification_selfie",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ141 - sv_bank_details
export const googleEvent_LOJ141 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "kyc_verification_selfie",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ141",
    event_name: "sv_bank_details",
    event_category: "screen_view",
    action: "view",
    level: "bank_details",
    screen_name: "bank_details",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ143 - bank_details_next_clk
export const googleEvent_LOJ143 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "kyc_verification_selfie",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ143",
    event_name: "bank_details_next_clk",
    event_category: "bank_details",
    action: "click",
    level: "next",
    screen_name: "bank_details",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ155 - sv_bank_details_fetched
export const googleEvent_LOJ155 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "emandate",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ155",
    event_name: "sv_bank_details_fetched",
    event_category: "screen_view",
    action: "view",
    level: "bank_details_fetched",
    screen_name: "bank_details_fetched",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ151 - sv_emandate
export const googleEvent_LOJ151 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "bank_details",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ151",
    event_name: "sv_emandate",
    event_category: "screen_view",
    action: "view",
    level: "emandate",
    screen_name: "emandate",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ158 - emandate_continue_clk
export const googleEvent_LOJ158 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "bank_details",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ158",
    event_name: "bank_details_fetch_continue_clk",
    event_category: "bank_details_fetched",
    action: "click",
    level: "continue",
    screen_name: "bank_details_fetched",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ153 - emandate_continue_clk
export const googleEvent_LOJ153 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "bank_details",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ153",
    event_name: "emandate_continue_clk",
    event_category: "emandate",
    action: "click",
    level: "continue",
    screen_name: "emandate",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ167 - sv_key_fct_stat
export const googleEvent_LOJ167 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ167",
    event_name: "sv_key_fct_stat",
    event_category: "screen_view",
    action: "view",
    level: "key_fact_statement",
    screen_name: "key_fact_statment",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

/*==============================================
Others Events
==============================================*/

// HOMO39 - home_dashboard_loan_not_required_vw
export const googleEvent_HOMO39 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",
    previous_screen: "enter_otp",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    lead_id: Number(localStorage.getItem("leadID")) || "",
  });

  analyticsEvent({
    event_id: "HOMO39",
    event_name: "home_dashboard_loan_not_required_vw",
    event_category: "home_dashboard",
    action: "view",
    level: "loan_not_required",
    screen_name: "home_dashboard",
    event_type_1: "backend",
    event_type_2: "interactive",
  });
};

// LOJ214 - sv_loan_reject
export const googleEvent_LOJ214 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ214",
    event_name: "sv_loan_reject",
    event_category: "screen_view",
    action: "view",
    level: "loan_reject",
    screen_name: "loan_reject",
    event_type_1: "backend",
    event_type_2: "non_interactive",
  });
};

// LOJ216 - loan_reject_continue_clk
export const googleEvent_LOJ216 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ216",
    event_name: "loan_reject_continue_clk",
    event_category: "loan_reject",
    action: "click",
    level: "continue",
    screen_name: "loan_reject",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ213 - kyc_verification_selfie_mismatch_vw
export const googleEvent_LOJ213 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ213",
    event_name: "kyc_verification_selfie_mismatch_vw",
    event_category: "kyc_verification",
    action: "view",
    level: "mismatch_selfie",
    screen_name: "kyc_verification_selfie",
    event_type_1: "backend",
    event_type_2: "non_interactive",
  });
};

// LOJ212 - emandate_name_mismatch_vw
export const googleEvent_LOJ212 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ212",
    event_name: "emandate_name_mismatch_vw",
    event_category: "emandate",
    action: "view",
    level: "penny_drop_name_mismatch",
    screen_name: "emandate",
    event_type_1: "backend",
    event_type_2: "interactive",
  });
};

// LOJ210 - kyc_verification_failed_digilocker_vw
export const googleEvent_LOJ210 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    kyc_mode: "digilocker",
  });

  analyticsEvent({
    event_id: "LOJ210",
    event_name: "kyc_verification_failed_digilocker_vw",
    event_category: "kyc_verification",
    action: "view",
    level: "kyc_failed_digilocker",
    screen_name: "kyc_verification",
    event_type_1: "backend",
    event_type_2: "non_interactive",
  });
};

// LOJ211 - kyc_verification_failed_aadhar_vw
export const googleEvent_LOJ211 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    kyc_mode: "aadhar",
  });

  analyticsEvent({
    event_id: "LOJ211",
    event_name: "kyc_verification_failed_aadhar_vw",
    event_category: "kyc_verification",
    action: "view",
    level: "kyc_failed_aadhar",
    screen_name: "kyc_verification",
    event_type_1: "backend",
    event_type_2: "non_interactive",
  });
};

// LOJ217 - pan_not_link_doc_linked_clk
export const googleEvent_LOJ217 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ217",
    event_name: "pan_not_link_doc_linked_clk",
    event_category: "pan_not_link",
    action: "click",
    level: "pan_aadhar_linked",
    screen_name: "pan_not_link",
    event_type_1: "backend",
    event_type_2: "interactive",
  });
};

// LOJ209 - pan_not_link_link_doc_clk
export const googleEvent_LOJ209 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ209",
    event_name: "pan_not_link_link_doc_clk",
    event_category: "pan_not_link",
    action: "click",
    level: "link_pan_aadhar",
    screen_name: "pan_not_link",
    event_type_1: "backend",
    event_type_2: "interactive",
  });
};

// LOJ007 - user_auth_name_del
export const googleEvent_LOJ007 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ007",
    event_name: "user_auth_name_del",
    event_category: "user_authenticity",
    action: "delete",
    level: "pancard_name",
    screen_name: "user_authenticity",
    event_type_1: "backend",
    event_type_2: "interactive",
  });
};

// LOJ008 - user_auth_email_fill
export const googleEvent_LOJ008 = (user_email) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    user_email: user_email,
  });

  analyticsEvent({
    event_id: "LOJ008",
    event_name: "user_auth_email_fill",
    event_category: "user_authenticity",
    action: "filled",
    level: "email",
    screen_name: "user_authenticity",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ009 - user_auth_email_del
export const googleEvent_LOJ009 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ009",
    event_name: "user_auth_email_del",
    event_category: "user_authenticity",
    action: "delete",
    level: "email",
    screen_name: "user_authenticity",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ010 - user_auth_err_<name|email>_vw
export const googleEvent_LOJ010 = (type) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ010",
    event_name: type === "name" ? "user_auth_err_name_vw" : "user_auth_err_email_vw",
    event_category: "user_authenticity",
    action: "view",
    level: type === "name" ? "error_in_name" : "error_in_email",
    screen_name: "user_authenticity",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ012 - pan_verification_pancard_fill
export const googleEvent_LOJ012 = (user_pancard) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    user_pancard: user_pancard,
  });

  analyticsEvent({
    event_id: "LOJ012",
    event_name: "pan_verification_pancard_fill",
    event_category: "pan_verification",
    action: "filled",
    level: "pancard_number",
    screen_name: "pan_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ013 - pan_verification_pancard_del
export const googleEvent_LOJ013 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ013",
    event_name: "pan_verification_pancard_del",
    event_category: "pan_verification",
    action: "delete",
    level: "pancard_number",
    screen_name: "pan_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ014 - pan_verification_err_pancard_vw
export const googleEvent_LOJ014 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ014",
    event_name: "pan_verification_err_pancard_vw",
    event_category: "pan_verification",
    action: "view",
    level: "error_in_pancard",
    screen_name: "pan_verification",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ015 - pan_verification_next_clk
export const googleEvent_LOJ015 = (user_pancard) => {
  ReactGA.set({
    user_properties: {
      session_id: generateSessionId(),
      customer_id: Cookies.get("customerID") || "",
      client_id: "",
      advertising_id: "",
      gclid: "",
      fcmtoken: "",
      user_type: convertUserType(),
      product_type: setProductNameByID(),

      platform: "web",
      app_version: localStorage.getItem("appVersion") ?? "",
      utm_source: localStorage.getItem("utm_source") ?? "",
      utm_medium: "",
      utm_campaign: "",
      utm_term: "",
      utm_content: "",
      user_insider: "0", // emp (1) / cust (0)
      flag_prod: "1",

      previous_screen: "bank_details_fetched",
      phone_number: getPhoneNo(),
      loan_type: setLoanType(),
      journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",

      user_pancard,
    },
  });

  ReactGA.event("pan_verification_next_clk", {
    event_id: "LOJ015",
    event_category: "pan_verification",
    action: "click",
    level: "next",
    screen_name: "pan_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });

  // setUserAttributes({
  //   session_id: generateSessionId(),
  //   customer_id: Cookies.get("customerID") || "",
  //   client_id: "",
  //   advertising_id: "",
  //   gclid: "",
  //   fcmtoken: "",
  //   user_type: convertUserType(),
  //   product_type: setProductNameByID(),

  //   platform: "web",
  //   app_version: localStorage.getItem("appVersion") ?? "",
  //   utm_source: localStorage.getItem("utm_source") ?? "",
  //   utm_medium: "",
  //   utm_campaign: "",
  //   utm_term: "",
  //   utm_content: "",
  //   user_insider: "0", // emp (1) / cust (0)
  //   flag_prod: "1",

  //   previous_screen: "bank_details_fetched",
  //   phone_number: getPhoneNo(),
  //   loan_type: setLoanType(),
  //   journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  //   user_pancard: user_pancard,
  // });

  // analyticsEvent({
  //   event_id: "LOJ015",
  //   event_name: "pan_verification_next_clk",
  //   event_category: "pan_verification",
  //   action: "click",
  //   level: "next",
  //   screen_name: "pan_verification",
  //   event_type_1: "frontend",
  //   event_type_2: "interactive",
  // });
};

// LOJ016 - pan_verification_back_clk
export const googleEvent_LOJ016 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ016",
    event_name: "pan_verification_back_clk",
    event_category: "pan_verification",
    action: "click",
    level: "back",
    screen_name: "pan_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ017 - pan_confirmation_info_correct_vw
export const googleEvent_LOJ017 = (user_pancard) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    user_pancard: user_pancard,
  });

  analyticsEvent({
    event_id: "LOJ017",
    event_name: "pan_confirmation_info_correct_vw",
    event_category: "pan_confirmation",
    action: "view",
    level: "info_correct",
    screen_name: "pan_confirmation",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ206 - sv_pan_not_link
export const googleEvent_LOJ206 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ206",
    event_name: "sv_pan_not_link",
    event_category: "screen_view",
    action: "view",
    level: "pan_not_link",
    screen_name: "pan_not_link",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ207 - pan_not_link_back_clk
export const googleEvent_LOJ207 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ207",
    event_name: "pan_not_link_back_clk",
    event_category: "pan_not_link",
    action: "click",
    level: "back",
    screen_name: "pan_not_link",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ208 - pan_not_link_doc_linked_clk
export const googleEvent_LOJ208 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ208",
    event_name: "pan_not_link_doc_linked_clk",
    event_category: "pan_not_link",
    action: "click",
    level: "pan_aadhar_linked",
    screen_name: "pan_not_link",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ020 - sv_contact_us
export const googleEvent_LOJ020 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
  });

  analyticsEvent({
    event_id: "LOJ020",
    event_name: "sv_contact_us",
    event_category: "screen_view",
    action: "view",
    level: "contact_us",
    screen_name: "contact_us",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ021 - contact_us_back_clk
export const googleEvent_LOJ021 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
  });

  analyticsEvent({
    event_id: "LOJ021",
    event_name: "contact_us_back_clk",
    event_category: "contact_us",
    action: "click",
    level: "back",
    screen_name: "contact_us",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ022 - contact_us_email_clk
export const googleEvent_LOJ022 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
  });

  analyticsEvent({
    event_id: "LOJ022",
    event_name: "contact_us_email_clk",
    event_category: "contact_us",
    action: "click",
    level: "email",
    screen_name: "contact_us",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ023 - contact_us_number_clk
export const googleEvent_LOJ023 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
  });

  analyticsEvent({
    event_id: "LOJ023",
    event_name: "contact_us_number_clk",
    event_category: "contact_us",
    action: "click",
    level: "number",
    screen_name: "contact_us",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ025 - kyc_verification_back_clk
export const googleEvent_LOJ025 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
  });

  analyticsEvent({
    event_id: "LOJ025",
    event_name: "kyc_verification_back_clk",
    event_category: "kyc_verification",
    action: "click",
    level: "back",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ026 - kyc_verification_back_clk
export const googleEvent_LOJ026 = (kyc_mode) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    kyc_mode: kyc_mode,
  });

  analyticsEvent({
    event_id: "LOJ026",
    event_name: "kyc_verification_digilocker_clk",
    event_category: "kyc_verification",
    action: "click",
    level: "verify_with_digilocker",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ027 - kyc_verification_aadhar_clk
export const googleEvent_LOJ027 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    kyc_mode: "aadhar",
  });

  analyticsEvent({
    event_id: "LOJ027",
    event_name: "kyc_verification_aadhar_clk",
    event_category: "kyc_verification",
    action: "click",
    level: "verify_with_aadhar",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ028 - kyc_verification_contact_us_clk
export const googleEvent_LOJ028 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ028",
    event_name: "kyc_verification_contact_us_clk",
    event_category: "kyc_verification",
    action: "click",
    level: "contact_us",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ030 - kyc_verification_aadhar_num_fill
export const googleEvent_LOJ030 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ030",
    event_name: "kyc_verification_aadhar_num_fill",
    event_category: "kyc_verification",
    action: "filled",
    level: "aadhar_number",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ031 - kyc_verification_aadhar_num_del
export const googleEvent_LOJ031 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ031",
    event_name: "kyc_verification_aadhar_num_del",
    event_category: "kyc_verification",
    action: "delete",
    level: "aadhar_number",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ032 - kyc_verification_aadhar_otp_fill
export const googleEvent_LOJ032 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ032",
    event_name: "kyc_verification_aadhar_otp_fill",
    event_category: "kyc_verification",
    action: "filled",
    level: "aadhar_otp",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ033 - kyc_verification_aadhar_otp_del
export const googleEvent_LOJ033 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ033",
    event_name: "kyc_verification_aadhar_otp_del",
    event_category: "kyc_verification",
    action: "delete",
    level: "aadhar_otp",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ034 - kyc_verification_aadhar_otp_resend_clk
export const googleEvent_LOJ034 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ034",
    event_name: "kyc_verification_aadhar_otp_resend_clk",
    event_category: "kyc_verification",
    action: "click",
    level: "resend_otp",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ035 - kyc_verification_err_aadhar_num_vw
export const googleEvent_LOJ035 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ035",
    event_name: "kyc_verification_err_aadhar_num_vw",
    event_category: "kyc_verification",
    action: "view",
    level: "error_aadhar_number",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ036 - kyc_verification_err_aadhar_otp_vw
export const googleEvent_LOJ036 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ036",
    event_name: "kyc_verification_err_aadhar_otp_vw",
    event_category: "kyc_verification",
    action: "view",
    level: "error_aadhar_otp",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ039 - kyc_verification_popup_success_vw
export const googleEvent_LOJ039 = (type) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    kyc_mode: "aadhar",
  });

  analyticsEvent({
    event_id: "LOJ039",
    event_name: "kyc_verification_popup_success_vw",
    event_category: "kyc_verification",
    action: "view",
    level: type === "success" ? "popup_success" : "popup_failure",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ041 - loan_purpose_back_clk
export const googleEvent_LOJ041 = (type) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ041",
    event_name: "loan_purpose_back_clk",
    event_category: "loan_purpose",
    action: "click",
    level: "back",
    screen_name: "loan_purpose",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ044 - loan_amount_back_clk
export const googleEvent_LOJ044 = (type) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ044",
    event_name: "loan_amount_back_clk",
    event_category: "loan_amount",
    action: "click",
    level: "back",
    screen_name: "loan_amount",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ045 - loan_amount_enter
export const googleEvent_LOJ045 = (loan_amount_bucket) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    loan_amount_bucket: setBucketValue(loan_amount_bucket),
  });

  analyticsEvent({
    event_id: "LOJ045",
    event_name: "loan_amount_enter",
    event_category: "loan_amount",
    action: "enter",
    level: "amount_bucket",
    screen_name: "loan_amount",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ048 - gender_back_clk
export const googleEvent_LOJ048 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ048",
    event_name: "gender_back_clk",
    event_category: "gender",
    action: "click",
    level: "back",
    screen_name: "gender",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ064 - employ_details_comp_name_fil
export const googleEvent_LOJ064 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ064",
    event_name: "employ_details_comp_name_fil",
    event_category: "employ_details",
    action: "filled",
    level: "company_name",
    screen_name: "employ_details",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ071 - proff_details_mon_income_fil
export const googleEvent_LOJ071 = (income_bucket) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    income_bucket: setBucketValue(income_bucket),
  });

  analyticsEvent({
    event_id: "LOJ071",
    event_name: "proff_details_mon_income_fil",
    event_category: "proff_details",
    action: "filled",
    level: `monthly_income_${setBucketValue(income_bucket)}`,
    screen_name: "proff_details_mon_income",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ081 - resi_details_residence_sel
export const googleEvent_LOJ081 = (residence_type) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    residence_type: residence_type,
  });

  analyticsEvent({
    event_id: "LOJ081",
    event_name: "resi_details_residence_sel",
    event_category: "resi_details",
    action: "select",
    level: `residence_${residence_type}`,
    screen_name: "resi_details_residence",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ226 - finbox_kyc_req_st
export const googleEvent_LOJ226 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ226",
    event_name: "finbox_kyc_req_st",
    event_category: "finbox",
    action: "sent",
    level: "kyc_request",
    screen_name: "kyc_verification",
    event_type_1: "backend",
    event_type_2: "interactive",
  });
};

// LOJ227 - finbox_kyc_res_success_rec
export const googleEvent_LOJ227 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ227",
    event_name: "finbox_kyc_res_success_rec",
    event_category: "finbox",
    action: "received",
    level: "kyc_response_success",
    screen_name: "kyc_verification",
    event_type_1: "backend",
    event_type_2: "non_interactive",
  });
};

// LOJ228 - finbox_kyc_res_failure_rec
export const googleEvent_LOJ228 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ228",
    event_name: "finbox_kyc_res_failure_rec",
    event_category: "finbox",
    action: "received",
    level: "kyc_response_failure",
    screen_name: "kyc_verification",
    event_type_1: "backend",
    event_type_2: "non_interactive",
  });
};

// LOJ229 - emandate_sucess_rec
export const googleEvent_LOJ229 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ229",
    event_name: "emandate_sucess_rec",
    event_category: "emandate",
    action: "received",
    level: "success",
    screen_name: "emandate",
    event_type_1: "backend",
    event_type_2: "non_interactive",
  });
};
